module.exports = function(ejs) {
var __t, __p = '';
__p += '<img class="ggs-gallery-thumb-preview__img" ggs-img-queue ggs-img-queue-events=":: $ctrl.thumbLoadCallbacks" ggs-img-queue-src=":: $ctrl.thumbUrl">';
return __p
}